import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;
const TOKEN_KEY = 'egea_admin_token';

const http = axios.create({ baseURL: API });
http.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ---- Auth -----------------------------------------------------------------
export async function loginAdmin(email, password) {
  try {
    const { data } = await http.post('/auth/login', { email, password });
    localStorage.setItem(TOKEN_KEY, data.token);
    return true;
  } catch (e) {
    return false;
  }
}

// ---- Users (admin) --------------------------------------------------------
export async function listUsers() {
  const { data } = await http.get('/users');
  return data;
}

export async function createUser(email, password) {
  const { data } = await http.post('/users', { email, password });
  return data;
}

export async function updateUser(id, password) {
  const { data } = await http.put(`/users/${id}`, { password });
  return data;
}

export async function deleteUser(id) {
  await http.delete(`/users/${id}`);
}

export function isAdmin() {
  return !!localStorage.getItem(TOKEN_KEY);
}

export function logoutAdmin() {
  localStorage.removeItem(TOKEN_KEY);
}

// ---- Client activation (campaign) ----------------------------------------
const CLIENT_TOKEN_KEY = 'egea_client_token';
const CLIENT_INFO_KEY = 'egea_client_info';

export async function activateToken(token) {
  const { data } = await http.post('/activare', { token });
  localStorage.setItem(CLIENT_TOKEN_KEY, data.token);
  localStorage.setItem(CLIENT_INFO_KEY, JSON.stringify({
    email: data.email, name: data.name, phone: data.phone, company: data.company, category: data.category,
  }));
  return data;
}

export function getClientInfo() {
  try { return JSON.parse(localStorage.getItem(CLIENT_INFO_KEY) || 'null'); } catch (e) { return null; }
}

export function isClient() {
  return !!localStorage.getItem(CLIENT_TOKEN_KEY);
}

export function logoutClient() {
  localStorage.removeItem(CLIENT_TOKEN_KEY);
  localStorage.removeItem(CLIENT_INFO_KEY);
}

function storeClientSession(data) {
  localStorage.setItem(CLIENT_TOKEN_KEY, data.token);
  localStorage.setItem(CLIENT_INFO_KEY, JSON.stringify({
    email: data.email, name: data.name, phone: data.phone, company: data.company, category: data.category,
  }));
  return data;
}

export async function registerAccount(payload) {
  const { data } = await http.post('/account/register', payload);
  return storeClientSession(data);
}

export async function loginAccount(email, password) {
  const { data } = await http.post('/account/login', { email, password });
  return storeClientSession(data);
}

export async function listDistribuitori() {
  const { data } = await http.get('/distribuitori');
  return data;
}

// Gated destination for a category: products if logged in, else the /cont gate.
export function categoryPath(key) {
  const enc = encodeURIComponent(key);
  return isClient() ? `/produse?categorie=${enc}` : `/cont?categorie=${enc}`;
}

// ---- Campaign tokens (admin) ----------------------------------------------
export async function createCampaignToken(payload) {
  const { data } = await http.post('/campaign/tokens', payload);
  return data;
}

export async function listCampaignTokens() {
  const { data } = await http.get('/campaign/tokens');
  return data;
}

export async function deleteCampaignToken(id) {
  await http.delete(`/campaign/tokens/${id}`);
}

// ---- Public reads ---------------------------------------------------------
export async function listItems(collection) {
  const { data } = await http.get(`/${collection}`);
  return data;
}

// ---- Admin writes ---------------------------------------------------------
export async function upsertItem(collection, item) {
  if (item.id) {
    const { data } = await http.put(`/${collection}/${item.id}`, item);
    return data;
  }
  const { data } = await http.post(`/${collection}`, item);
  return data;
}

export async function deleteItem(collection, id) {
  await http.delete(`/${collection}/${id}`);
}

export async function resetDemo() {
  await http.post('/admin/reset-demo');
}

// ---- Leads ----------------------------------------------------------------
export async function addLead(lead) {
  const { data } = await http.post('/leads', lead);
  return data;
}

// ---- Files ----------------------------------------------------------------
export async function uploadFile(file, category = 'foto') {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('category', category);
  const { data } = await http.post('/upload', fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data; // { id, url, name, type, content_type, category }
}

export async function listMedia(category) {
  const { data } = await http.get('/media', { params: category ? { category } : {} });
  return data;
}

export async function listPublicMedia() {
  const { data } = await http.get('/media/public');
  return data;
}

export async function deleteMedia(id) {
  await http.delete(`/media/${id}`);
}

// Resolve a stored media reference to an absolute URL.
export function fileUrl(u) {
  if (!u) return u;
  return /^https?:\/\//.test(u) ? u : `${BASE}${u}`;
}
